// extracted by mini-css-extract-plugin
module.exports = {"image":"section-sixtine-module--image--1a-NY"};